import * as v from "valibot";

import { rpcContract } from "../rpc";

export const urlEnricherRpcContract = rpcContract({
  name: "urlEnricher",
  paramsSchema: v.object({
    url: v.pipe(v.string(), v.url()),
  }),
  resultSchema: v.object({
    url: v.string(),
    title: v.nullable(v.string()),
    ogImage: v.nullable(v.string()),
    imageFile: v.nullable(v.string()),
  }),
});

export type UrlEnricherParams = v.InferOutput<(typeof urlEnricherRpcContract)["paramsSchema"]>;
export type UrlEnricherResult = v.InferOutput<(typeof urlEnricherRpcContract)["resultSchema"]>;
